import actions from '../../../constants/actionTypes';
import { COMMON_CONST } from '../../../constants/constants';
import {
  handleChangeTableActivePage,
  handleChangeTablePageSize,
  handleCloseDialogGeneric,
  handleOpenDialogGeneric,
} from '../../../redux/genericReducerHandler';
import { EnumPage, EnumTypeForm } from '../../../constants/enum';

const initialState = {
  table: {
    itemList: [],
    totalSize: 0,
    activePage: 1,
    pageSize: COMMON_CONST.PageSize,
  },
  dialog: {
    isOpenDialog: false,
    typeForm: EnumTypeForm.CREATE.id,
    airpayStoreId: 0,
    unlinkedRestaurants: [],
    activeEmailUpdate: {
      isOpenDialog: false,
      title: '',
      email: '',
    },
    walletItem: {},
  },
  walletRestaurant: {
    isOpenDialog: false,
    isOpenAddRestaurantDialog: false,
    airpayStoreId: 0,

    table: {
      itemList: [],
      totalSize: 0,
      activePage: 1,
      pageSize: COMMON_CONST.PageSize,
    },
  },
};

function walletManagementReducer(state = initialState, action) {
  const PAGE = EnumPage.WALLET_MANAGEMENT.id;
  const { response, type } = action;
  switch (type) {
    case actions.OPEN_DIALOG_GENERIC: {
      return handleOpenDialogGeneric(PAGE, state, action);
    }
    case actions.CLOSE_DIALOG_GENERIC: {
      return handleCloseDialogGeneric(PAGE, state, action);
    }
    case actions.CHANGE_TABLE_PAGE_SIZE: {
      return handleChangeTablePageSize(PAGE, state, action);
    }
    case actions.CHANGE_TABLE_ACTIVE_PAGE: {
      return handleChangeTableActivePage(PAGE, state, action);
    }

    case actions.RECEIVE_LIST_USER_WALLET: {
      const { itemList, totalSize } = response;
      return {
        ...state,
        table: {
          ...state.table,
          itemList,
          totalSize,
        },
        dialog: {
          ...state.dialog,
          airpayStoreId: 0,
          isOpenDialog: false,
        },
        walletRestaurant: {
          ...state.walletRestaurant,
          airpayStoreId: 0,
          isOpenDialog: false,
          isOpenAddRestaurantDialog: false,
        },
      };
    }

    case actions.RECEIVE_USER_WALLET_RESTAURANT: {
      const { itemList, airpayStoreId } = response;
      return {
        ...state,
        walletRestaurant: {
          ...state.walletRestaurant,
          isOpenDialog: true,
          airpayStoreId,
          isOpenAddRestaurantDialog: false,
          table: {
            ...state.walletRestaurant.table,
            itemList,
          },
        },
      };
    }

    case actions.CLOSE_USER_WALLET_RESTAURANT_MODAL: {
      return {
        ...state,
        walletRestaurant: {
          ...state.walletRestaurant,
          isOpenDialog: false,
        },
      };
    }

    case actions.OPEN_UPDATE_USER_WALLET_MODAL: {
      const { airpayStoreId, walletItem } = response;
      return {
        ...state,
        dialog: {
          ...state.dialog,
          isOpenDialog: true,
          typeForm: EnumTypeForm.UPDATE.id,
          airpayStoreId,
          walletItem,
        },
      };
    }

    case actions.OPEN_CREATE_USER_WALLET_MODAL: {
      return {
        ...state,
        dialog: {
          ...state.dialog,
          typeForm: EnumTypeForm.CREATE.id,
          isOpenDialog: true,
          airpayStoreId: 0,
        },
      };
    }

    case actions.RECEIVE_LIST_UNLINKED_RESTAURANT: {
      const { unlinkedRestaurants } = response;
      return {
        ...state,
        dialog: {
          ...state.dialog,
          unlinkedRestaurants,
        },
      };
    }

    case actions.OPEN_ADD_RESTAURANT_USER_WALLET_MODAL: {
      return {
        ...state,
        walletRestaurant: {
          ...state.walletRestaurant,
          isOpenAddRestaurantDialog: true,
        },
      };
    }

    case actions.CLOSE_ADD_RESTAURANT_USER_WALLET: {
      return {
        ...state,
        walletRestaurant: {
          ...state.walletRestaurant,
          isOpenAddRestaurantDialog: false,
        },
      };
    }

    case actions.SET_TOGGLE_OPEN_ACTIVE_EMAIL_MODAL: {
      const { isOpenDialog, email, title } = response;
      return {
        ...state,
        dialog: {
          activeEmailUpdate: {
            isOpenDialog,
            email,
            title,
          },
        },
      };
    }

    case actions.CHANGE_TABLE_ACTIVE_PAGE_WALLET_RESTAURANT: {
      const { activePage } = response;
      return {
        ...state,
        walletRestaurant: {
          ...state.walletRestaurant,
          table: {
            ...state.walletRestaurant.table,
            activePage,
          },
        },
      };
    }

    case actions.CHANGE_TABLE_PAGE_SIZE_WALLET_RESTAURANT: {
      const { pageSize } = response;
      return {
        ...state,
        walletRestaurant: {
          ...state.walletRestaurant,
          table: {
            ...state.walletRestaurant.table,
            pageSize,
          },
        },
      };
    }

    default:
      return state;
  }
}

export default walletManagementReducer;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/reducers.js